import type { CopyShape } from "../../intl";

import type { PLAN_INQUIRY_COPY_PT_BR } from "../plan-inquiry.copy";

export const PLAN_INQUIRY_COPY_EN_US: CopyShape<typeof PLAN_INQUIRY_COPY_PT_BR> = {
  sentTitle: "You're all set!",
  description: "Tell us how big your operation is and we'll put together the right proposal.",
  sentDescription: "We got your request.",
  closeLabel: "Close",
  nameLabel: "Your name",
  emailLabel: "Your email",
  whatsappLabel: "WhatsApp with area code",
  creatorsCountLabel: "How many creators (optional)",
  messageLabel: "Anything else you'd like to share? (optional)",
  sentMessage:
    "We'll hit you up on WhatsApp or at the email you left to sort out the next steps.",
  errorMessage: "We couldn't send it right now. Try again in a moment.",
  submitLabel: "Send request",
  submittingLabel: "Sending...",
  requestProposal: {
    description: "Tell us how big your operation is and we'll put together the right proposal.",
    needsPhoneDescription:
      "Just confirm your phone number — that's how we'll let you know when the proposal is ready.",
    sentMessage:
      "We'll hit you up on WhatsApp or at your account email to sort out the next steps.",
    nameLabel: "Name",
    emailLabel: "Email",
    whatsappLabel: "WhatsApp",
    empty: "—",
    creatorsCountLabel: "How many creators",
    optional: "(optional)",
    creatorsSuffix: "creators",
    submit: "Request a proposal",
  },
  phoneVerification: {
    phoneLabel: "WhatsApp",
    phoneHint: "That's how we'll let you know when the proposal is ready.",
    codeLabel: "Code received by SMS",
    confirm: "Confirm and send request",
    resend: "Resend code",
    sendCode: "Send code by SMS",
  },
};
